import React from 'react';

function UsersList({ users, currentUserId }) {
  return (
    <div className="users-list">
      <h4>Active Users ({users.length})</h4>
      <div className="users-items">
        {users.map((user) => (
          <div key={user.id} className="user-item">
            <div 
              className="user-avatar" 
              style={{ backgroundColor: user.color }}
            >
              {user.name.charAt(0).toUpperCase()}
            </div>
            <span className="user-name">
              {user.name}
              {user.id === currentUserId && ' (You)'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default UsersList;